import React, { useState, useEffect } from 'react';
import Logo from '../assets/my.jpg';

export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 990);
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 990);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleNavigation = (sectionId) => {
    setActiveSection(sectionId);
    let targetElement = null;

    switch (sectionId) {
      case 'me':
        targetElement = document.getElementById('HeroSection');
        break;
      case 'projects':
        targetElement = document.getElementById('ProjectSection');
        break;
      case 'whyme':
        targetElement = document.getElementById('SpringDetails');
        break;
      case 'contact':
        targetElement = document.getElementById('Worktogether');
        break;
      default:
        break;
    }

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }

    setIsMenuOpen(false);
  };
  const handleClose = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className={isSticky ? 'sticky header-main' : 'header-main'}>
      <div className="header-inner">
        <div className="header-logo">
          <img src={Logo} alt="Logo" />
          <div
          // style={{
          //   display: 'flex',
          //   flexDirection: 'column',
          //   backgroundColor: 'white',
          // }}
          >
            <p className="hello-h">Muhammad Aman</p>
            <div className="active">
              <div className="active2">
                <div className="active3" />
              </div>
              <p className="hello-subH">available for hire</p>
            </div>
          </div>
        </div>
        {!isMobile ? (
          <div className="header-ul-links">
            <ul className="main_menu">
              <li className={activeSection === 'me' ? 'is-current' : ''}>
                <button type="button" onClick={() => handleNavigation('me')}>
                  ME
                </button>
              </li>
              <li className={activeSection === 'projects' ? 'is-current' : ''}>
                <button
                  type="button"
                  onClick={() => handleNavigation('projects')}
                >
                  PROJECTS
                </button>
              </li>
              <li className={activeSection === 'whyme' ? 'is-current' : ''}>
                <button type="button" onClick={() => handleNavigation('whyme')}>
                  WHY ME?
                </button>
              </li>
              <li className={activeSection === 'contact' ? 'is-current' : ''}>
                <button
                  type="button"
                  onClick={() => handleNavigation('contact')}
                >
                  LETS TALK
                </button>
              </li>
            </ul>
          </div>
        ) : (
          <div className="drawer-handler">
            <button
              type="button"
              aria-label="menu"
              className="hamburg-menu-wrapper"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span />
              <span />
              <span className="last-span" />
            </button>
          </div>
        )}
      </div>
      {isMobile && isMenuOpen && (
        <div className="mobile-menu open">
          <div
            className="Close-div"
            aria-label="Close-div"
            role="button"
            tabIndex={0}
            onClick={handleClose}
            onKeyDown={(e) => e.key === 'Enter' && handleClose()}
          />

          <ul>
            <li className={activeSection === 'me' ? 'is-current' : ''}>
              <button type="button" onClick={() => handleNavigation('me')}>
                ME
              </button>
            </li>
            <li className={activeSection === 'projects' ? 'is-current' : ''}>
              <button
                type="button"
                onClick={() => handleNavigation('projects')}
              >
                PROJECTS
              </button>
            </li>
            <li className={activeSection === 'whyme' ? 'is-current' : ''}>
              <button type="button" onClick={() => handleNavigation('whyme')}>
                WHY ME?
              </button>
            </li>
            <li className={activeSection === 'contact' ? 'is-current' : ''}>
              <button type="button" onClick={() => handleNavigation('contact')}>
                LETS TALK
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
